// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"524":"62fbce7b","580":"4c4cbf13"}[chunkId] + ".chunk.css";
};